import { navigation } from '@exploration/cms-constants';
import { ADVISOR_URL } from '@exploration/ui-utils';

export const getDefaultData = () => ({
  callToAction: {
    [navigation.financial_advice_navigation_links
      .advice_services_free_money_coaching]: {
      href: 'https://www.thrivent.com/generosity/money-canvas',
      text: 'Free Money Coaching',
    },
    [navigation.financial_advice_navigation_links
      .advice_services_dedicated_planning]: {
      href: 'https://www.thrivent.com/advice/dedicated-planning-services',
      text: 'Dedicated Planning',
    },
    [navigation.financial_advice_navigation_links
      .advice_services_managed_accounts]: {
      href: 'https://www.thrivent.com/investments/managed-accounts',
      text: 'Managed Accounts',
    },
    [navigation.financial_advice_navigation_links
      .advice_services_personal_trust]: {
      href: 'https://www.thrivent.com/advice/trust-services',
      text: 'Personal Trust',
    },

    [navigation.financial_advice_navigation_links
      .financial_goals_starting_out_financially]: {
      href: 'https://www.thrivent.com/insights/starting-out-financially',
      text: 'Starting Out Financially',
    },
    [navigation.financial_advice_navigation_links
      .financial_goals_balancing_work_and_family]: {
      href: 'https://www.thrivent.com/insights/balancing-work-family',
      text: 'Balancing Work & Family',
    },
    [navigation.financial_advice_navigation_links
      .financial_goals_nearing_retirement]: {
      href: 'https://www.thrivent.com/insights/nearing-retirement',
      text: 'Nearing Retirement',
    },
    [navigation.financial_advice_navigation_links
      .financial_goals_living_in_retirement]: {
      href: 'https://www.thrivent.com/insights/living-in-retirement',
      text: 'Living in Retirement',
    },
    [navigation.financial_advice_navigation_links
      .working_with_a_financial_advisor]: {
      href: 'https://www.thrivent.com/working-with-a-financial-advisor',
      text: 'Working with a financial advisor',
    },
    [navigation.financial_advice_promo_card
      .financial_advice_promo_card_call_to_action]: {
      href: ADVISOR_URL,
      text: 'Start your search',
    },
  },
  image: {},
  list: {},
  text: {
    [navigation.financial_advice_navigation_links
      .financial_advice_advice_services_title]: 'Advice Services',
    [navigation.financial_advice_navigation_links
      .financial_advice_advice_goals_title]: 'Financial Goals',
    [navigation.financial_advice_navigation_links.financial_advice_title]:
      'Financial Advice',
    [navigation.financial_advice_navigation_links.financial_advice_description]:
      'Explore our financial planning services',
    [navigation.financial_advice_promo_card
      .financial_advice_promo_card_description]:
      'Get started on your journey to financial confidence today.',
    [navigation.financial_advice_promo_card.financial_advice_promo_card_title]:
      'Find a financial advisor',
  },
  video: {},
});
